import { useInstance } from 'intact-vue-next';
import dayjs from 'dayjs';
import { clearTime, isEqual } from './helpers';
export function useDays(showDate, status, focusDate) {
  var instance = useInstance();
  function getDays(now) {
    var days = [];
    // dayjs is immutable, so we convert to native Date
    var start = showDate.value.toDate();
    var month = start.getMonth();
    start.setDate(1);
    clearTime(start);
    var startWeekday = start.getDay();
    start.setDate(1 - startWeekday);
    for (var i = 0; i < 42; i++) {
      var dayjsDate = dayjs(start);
      var _date = start.getDate();
      var _month = start.getMonth();
      var isExceed = _month !== month;
      days.push({
        isExceed: isExceed,
        isActive: !isExceed && status.isActive(dayjsDate, 'date'),
        isToday: isEqual(now, dayjsDate),
        isDisabled: status.isDisabled(dayjsDate),
        isHover: isEqual(focusDate.value, dayjsDate),
        isInRange: !isExceed && status.isInRange(dayjsDate, 'date'),
        label: _date,
        value: dayjsDate
      });
      start.setDate(start.getDate() + 1);
    }
    return days;
  }
  return {
    getDays: getDays,
    onClick: instance.triggerChange
  };
}